import { FeedFilterContentItemType } from 'src/api/interfaces/requests'

const POST_DISPLAY_MODE_ADMIN = 'admin'
export const POST_DISPLAY_MODE_BANNER = 'banner'
export const POST_DISPLAY_MODE_COMPACT = 'compact'
export const POST_DISPLAY_MODE_DETAIL = 'detail'
export const POST_DISPLAY_MODE_PREVIEW = 'preview'

export type PostDisplayMode = typeof POST_DISPLAY_MODE_ADMIN |
  typeof POST_DISPLAY_MODE_BANNER |
  typeof POST_DISPLAY_MODE_COMPACT |
  typeof POST_DISPLAY_MODE_DETAIL |
  typeof POST_DISPLAY_MODE_PREVIEW;

export const mapDisplayModeToConst: { [key in PostDisplayMode]: PostDisplayMode } = {
  admin: POST_DISPLAY_MODE_ADMIN,
  banner: POST_DISPLAY_MODE_BANNER,
  compact: POST_DISPLAY_MODE_COMPACT,
  detail: POST_DISPLAY_MODE_DETAIL,
  preview: POST_DISPLAY_MODE_PREVIEW
}

export const PURPOSE_BASIC = 'basic_ingredient'
export const PURPOSE_MEDIA = 'media'
export const PURPOSE_MEDIA_CANDIDATE = 'media_candidate'

export type Purpose = typeof PURPOSE_BASIC | typeof PURPOSE_MEDIA | typeof PURPOSE_MEDIA_CANDIDATE

export type DisplaySettings<S>={
  [key in PostDisplayMode]: {
    [basic in typeof PURPOSE_BASIC]: S
  } & {
    [purpose in Exclude<Purpose, typeof PURPOSE_BASIC>]?: S
  }
}

export type PostSchema = 'NewsArticle' | 'Event';

export interface IComments {
  number: number;
  urls: {
    create: string;
    get: string;
  };
}

export type IContentItemType = 'publicPost' | 'privatePost' | 'event' | 'survey' | FeedFilterContentItemType;
